var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dataset-sources"},[_c('ul',{staticClass:"dataset-sources-list"},_vm._l((_vm.sources),function(source,index){return _c('DatasetSource',{key:index,attrs:{"source":source}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }